import { render, staticRenderFns } from "./DetailsDialog.vue?vue&type=template&id=e90e7e3c&scoped=true&"
import script from "./DetailsDialog.vue?vue&type=script&lang=js&"
export * from "./DetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./DetailsDialog.vue?vue&type=style&index=0&id=e90e7e3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90e7e3c",
  null
  
)

export default component.exports